import { useUserStore } from '../store/userStore';

export function useIsAllowed(allowedRoles: readonly string[]): boolean {
  const role = useUserStore((state) => state.user?.role);
  return role !== undefined && allowedRoles.includes(role);
}
